import Box from '@mui/material/Box';
import './Dropdown.style.css';

const WrapperStyle = {
    bgcolor: 'background.default',
    color: 'text.primary',
};

export const Dropdown = ({ children }) => {
    return (
        <Box sx={WrapperStyle} className="dropdown-content">
            {children}
        </Box>
    );
};
